/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actiontypes from './actiontypes';

const initialState = {
  manu_artbl: [],
  manu_arfld: [],
  unallocated: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actiontypes.MANU_AR_TBL_DATA:
      let getManFactRecPgmVal = Object.keys(action.payload)[0];
      if (state.manu_artbl.length != 0) {
        let main = state?.manu_artbl?.forEach(function (obj) {
          delete obj[getManFactRecPgmVal];
        });
      }
      return {
        ...state,
        manu_artbl: [...state.manu_artbl, action.payload],
      };
    case actiontypes.MANU_AR_FLD_DATA:
      let getManFactRecFldPgmVal = Object.keys(action.payload)[0];
      if (state.manu_arfld.length != 0) {
        let main = state?.manu_arfld?.forEach(function (obj) {
          delete obj[getManFactRecFldPgmVal];
        });
      }
      return {
        ...state,
        manu_arfld: [...state.manu_arfld, action.payload],
      };
    case actiontypes.MANU_AR_UNALLOCATED_VAL:
      if (
        action.payload &&
        typeof action.payload === 'object' &&
        Object.keys(action.payload).length > 0
      ) {
        let getManFactRecAllCPgmVal = Object.keys(action.payload)[0];

        if (state.unallocated.length !== 0) {
          // Iterate over the unallocated array and delete the property from each object
          state.unallocated.forEach(function (obj) {
            delete obj[getManFactRecAllCPgmVal];
          });
        }

        return {
          ...state,
          unallocated: [...state.unallocated, action.payload], // Add new payload to the unallocated array
        };
      } else {
        // Handle case where action.payload is not a valid object
        console.error('Invalid payload: ', action.payload);
        return state; // Return current state if payload is invalid
      }

    case actiontypes.MANU_AR_SHOW_SELECT:
      return { ...state, show_select: action.payload };
    case actiontypes.AR_MANU_NAV_DATA:
      return { ...state, ar_manu: action.payload };
    case actiontypes.NDC_DETAIL_SIGNLE_MFG:
      return { ...state, mfgndc_sgl: action.payload };
    case actiontypes.NDC_DETAIL_ALL_MFG:
      return { ...state, mfgndc_all: action.payload };
    case actiontypes.MFG_AR_FIRST_LOAD:
      return { ...state, mfgArFirstLoad: action.payload };
    case actiontypes.MFG_ACCOUNT_REC_CLEAR_REDUX:
      return { val: action.payload };
    default:
      return state;
  }
};

export default reducer;
